module.exports = __webpack_public_path__ + "static/media/imove.c8c4e7a0.svg";